export default "__VITE_ASSET__APiyO5kx__"